import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../lib/LanguageContext';
import { translations } from '../lib/translations';
export function Navigation() {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].nav;
  const navItems = [{
    label: t.home,
    path: '/'
  }, {
    label: t.about,
    path: '/about'
  }, {
    label: t.why,
    path: '/why-white-box'
  }, {
    label: t.products,
    path: '/products'
  }, {
    label: t.industry,
    path: '/industry'
  }, {
    label: t.contact,
    path: '/contact'
  }];
  return <nav style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '64px',
    backgroundColor: 'rgba(8, 8, 8, 0.90)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 2rem',
    zIndex: 100,
    borderBottom: '1px solid rgba(68, 68, 68, 0.3)'
  }} data-id="element-58">
      {/* Left: Logo */}
      <NavLink to="/" style={{
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center'
    }} data-id="element-59">
        <img src="https://cdn.magicpatterns.com/uploads/nEGD9QNojYvhr4g8MWwNuB/big_W_only_logo.png" alt="w.ai" style={{
        height: '52px',
        width: 'auto',
        filter: 'invert(1)'
      }} data-id="element-60" />
      </NavLink>

      {/* Right: Nav links */}
      <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '2.5rem'
    }} data-id="element-61">
        {navItems.map(item => <NavLink key={item.path} to={item.path} end={item.path === '/'} style={({
        isActive
      }) => ({
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.7rem',
        letterSpacing: '0.25em',
        textTransform: 'uppercase',
        color: isActive ? 'var(--white)' : 'var(--grey-500)',
        textDecoration: 'none',
        transition: 'color 0.2s ease'
      })} data-id="element-62">
            {item.label}
          </NavLink>)}
      </div>
    </nav>;
}